import { IconButton } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '../../utils/svgIcons';


const formatDate = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    // Format date manually as DD/MM/YYYY
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Format time using toLocaleTimeString
    const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
    });

    return `${formattedDate}, ${formattedTime}`;
};

function GetLeadDetails({ leadDetails, leadDetailsMap, handleVIewLeadDetailsInaccordion }) {
    const [expandedLeadId, setExpandedLeadId] = useState(null);

    const sourceType = useMemo(() => ({
        1: 'Landing Page', 2: 'Fresh Work', 3: 'FTBV', 4: 'Inquiry',
        5: 'Whatsapp', 6: 'New Fresh Marketer', 7: 'BotBuz', 8: 'Excel', 9: 'Vidyut Freshmarketer', 10: 'RENAV-FORM-INQUIRY',
        11: 'TVS-LP', 12: 'RENAV-WHATSAPP', 13: 'HP-LP', 14: 'VIDA-LP', 15: 'CL', 16: 'TP', 17: 'DS', 18: 'RENAV-MISSED-CALL',
        19: 'RENAV-WHATSAPP-547', 20: 'RENAV-WHATSAPP-348', 21: 'RENAV-WHATSAPP-563', 22: 'RENAV-WHATSAPP-507',
        23: 'RENAV-WHATSAPP-742', 24: 'DIRECT-EXCEL', 25: "DIALSHREE-INBOUND-LEADS", 26: "OLA-EXCEL-IMPORT", 27: "GOOGLE-ADS", 28: "AMPERE-EXCEL-IMPORT", 29: "RETARGETTING"
    }), []);

    const groupedLeads = [...new Map(leadDetails.map(lead => [lead.mobile, lead])).values()];

    const toggleExpand = async (leadId) => {
        if (expandedLeadId === leadId) {
            setExpandedLeadId(null); // collapse
        } else {
            await handleVIewLeadDetailsInaccordion(leadId); // call API
            setExpandedLeadId(leadId); // expand
        }
    };

    return (
        <>
            {groupedLeads.map((lead, index) => (
                <div key={`${lead._id}-${index}`} className="mb-2 text-sm text-gray-700">
                    Viewing lead history of <b>{lead.mobile}</b>
                </div>
            ))}

            <table className="w-full border text-sm">
                <thead>
                    <tr className="bg-success text-white text-left">

                        <th className="p-2 border">Created At</th>
                        <th className="p-2 border">Source</th>
                        <th className="p-2 border">SubSource</th>
                        <th className="p-2 border">cbrand</th>
                        <th className="p-2 border">Name</th>
                        <th className="p-2 border">Mobile</th>
                        <th className="p-2 border">Pincode</th>
                        <th className="p-2 border">Vehicle</th>
                        <th className="p-2 border">Brand</th>
                        <th className="p-2 border">UTM Medium</th>
                        <th className="p-2 border">UTM Campaign</th>
                        <th className="p-2 border">UTM Content</th>
                        <th className="p-2 border">UTM Term</th>
                        <th className="p-2 border">Ad Group</th>
                        <th className="p-2 border">Ola Verification</th>
                        <th className="p-2 border">Ola Expiry</th>
                        <th className="p-2 border">Ola status</th>
                        <th className="p-2 border">Revolt Lead Process</th>
                        <th className="p-2 border">Pushed To Revolt</th>
                        <th className="p-2 border">Tvs Verification</th>
                        <th className="p-2 border">Pushed To Tvs</th>
                        <th className="p-2 border">Pushed To Ampere</th>
                        <th className="p-2 border">Pushed To Simple</th>
                        <th className="p-2 border">Simple Verification</th>
                        <th className="p-2 border">Actions</th>
                    </tr>
                </thead>
                <tbody>

                    {leadDetails.map((lead, index) => {
                        const isExpanded = expandedLeadId === lead._id;
                        const journey = leadDetailsMap?.[lead._id] || [];
                        return (
                            <React.Fragment key={`${lead._id}-${index}`}>
                                <tr>
                                    {[
                                        "createdAt", "source", "subSource", "cbrand", "name", "mobile", "pincode", "vehicle", "brand",
                                        "utm_medium", "utm_campaign", "utm_content", "utm_term", "ad_group",
                                        "ola_verification", "ola_expiry", "ola_status",
                                        "revolt_Lead_Process", "pushed_to_revolt", "tvs_verification", "pushed_to_tvs", "pushed_to_ampere",
                                        "pushed_to_simple", "simple_verification"
                                    ].map((key) => {
                                        const value = lead[key];
                                        let displayValue = "N/A";

                                        if (key === "createdAt") {
                                            displayValue = formatDate(value);
                                        } else if (key === "source") {
                                            displayValue = sourceType[value] || `Unknown (${value})`;
                                        } else if (key === "ola_verification") {
                                            displayValue = value === 1 ? "Accepted" :
                                                value === 2 ? "Rejected" :
                                                    value === 3 ? "Un Processed" :
                                                        value === 4 ? "Duplicate" :
                                                            value === 7 ? "Store(B)" :
                                                                value === 8 ? "Store(A)" :
                                                                    value === 5 ? "Not Eligible" : "N/A";
                                        } else if (key === "pushed_to_ampere") {
                                            displayValue = value === 1 ? "Success" :
                                                value === 2 ? "UnSuccess" :
                                                    value === 3 ? "Duplicate" : "N/A";
                                        } else if (key === "pushed_to_revolt") {
                                            displayValue = value === 1 ? "Accepted" :
                                                value === 2 ? "Rejected" : "N/A";
                                        } else if (key === "revolt_Lead_Process") {
                                            displayValue = value === 0 ? "Pending" :
                                                value === 1 ? "Completed" :
                                                    value === 2 ? "Duplicate" :
                                                        value === 3 ? "Failed" : "NA";
                                        } else if (key === "pushed_to_tvs") {
                                            displayValue = value === 1 ? "Completed" :
                                                value === 2 ? "Pending" :
                                                    value === 3 ? "Rejected" :
                                                        value === 4 ? "Not Eligible" :
                                                            value === 5 ? "DUPLICATE_LEAD" :
                                                                value === 6 ? "Failed to allocate dealer" :
                                                                    value === 7 ? "INVALID_PINCODE" :
                                                                        value === 8 ? "Success" :
                                                                            "N/A"
                                        }
                                        else if (key === "tvs_verification") {
                                            displayValue = value === 1 ? "Accepted" :
                                                value === 2 ? "Rejected" :
                                                    value === 3 ? "Un Processed" :
                                                        value === 4 ? "Duplicate" :
                                                            value === 5 ? "Dealer Not Found" :
                                                                value === 6 ? "Old Leads" : "N/A";
                                        } else if (key === "simple_verification" || key === "simple_status") {
                                            displayValue = value === 1 ? "Accepted" :
                                                value === 2 ? "Rejected" :
                                                    value === 3 ? "Pending" :
                                                        value === 4 ? "Duplicate" : "N/A";
                                        } else if (key === "pushed_to_simple") {
                                            displayValue = value === 1 ? "Success" :
                                                value === 2 ? "Pending" :
                                                    value === 3 ? "Failed" :
                                                        value === 4 ? "Duplicate" : "N/A";
                                        } else {
                                            displayValue = value !== undefined && value !== null ? (typeof value === "object" ? JSON.stringify(value) : String(value)) : "N/A";
                                        }

                                        return (
                                            <td key={key} className="p-2 border">
                                                {displayValue}
                                            </td>
                                        );
                                    })}

                                    <td className="p-2 border text-center">
                                        {/* <button
                                            onClick={() => setExpandedLeadId(isExpanded ? null : lead._id)}
                                            className="text-blue-600 underline"
                                        >
                                            {isExpanded ? "Hide Details" : "View Details"}
                                        </button> */}
                                        <IconButton aria-label="expand row" size="small" onClick={() => toggleExpand(lead._id)}>
                                            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </IconButton>
                                    </td>
                                </tr>
                                {isExpanded && (
                                    <tr>
                                        <td colSpan="25"className="bg-[#48719230] border !py-4 px-4 m-0">
                                            <p className="font-bold mb-2 text-small">{lead.mobile} Lead Journey:</p>
                                            {journey.length > 0 ? (
                                                <div className="overflow-x-auto">
                                                    <table className="w-full border text-sm">
                                                        <thead className="bg-success text-white text-left">
                                                            <tr>
                                                                {Object.keys(journey[0]).map((key) => (
                                                                    <th key={key} className="border px-2 py-1 capitalize">
                                                                        {key}
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {journey.map((entry, index) => (
                                                                <tr key={index}>
                                                                    {Object.entries(entry).map(([key, value]) => (
                                                                        <td key={key} className="border px-2 py-1">
                                                                            {key === 'date' ? formatDate(value) : (typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value ?? "-"))}
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p className="text-gray-500 italic">No journey data available.</p>
                                            )}
                                        </td>
                                    </tr>
                                )}


                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
}

export default GetLeadDetails;
